/**
 * What an action button on a row looks like -- the Chat, Seguimiento,
 * Completar pago, Editar, Eliminar buttons that sit at the foot of a booking
 * card, a listing card or a list row.
 *
 * One object, because there used to be two. Both booking lists chose between
 * them by device:
 *
 *   variant === 'card' ? { shape: 'round', className: ... } : { style: { minHeight: 44 } }
 *
 * 'card' was mobile and 'list' was desktop, so desktop was opting out of the
 * app's own pill button by construction and getting a plain antd rectangle
 * with an oversized touch height -- on the one device that has no touch. The
 * hover treatment the class carries was, for its part, locked inside a
 * max-width:767px media query, so it only ever applied where there is no
 * mouse. Both halves of the same mistake, in opposite directions.
 */
export const actionButtonProps = {
  shape: 'round' as const,
  className: 'heavyDutyMachinery-card-action-btn',
};
